import { render, staticRenderFns } from "./pageSchema.vue?vue&type=template&id=6a89c540&"
import script from "./pageSchema.vue?vue&type=script&lang=js&"
export * from "./pageSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports